import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic, faCalendar, faUser, faPlay } from "@fortawesome/free-solid-svg-icons";
import {Link} from 'react-router-dom'
import credentials from "../../assets/credentials";

const MusicList = ({ tracks, title, url }) => {
  if (!tracks || tracks.length<1) return <h1>No recent track</h1>
  return (
    <div className="max-w-4xl mx-auto mt-2 bg-gray-900 shadow-md p-4 pt-0 rounded-lg">
      <h3 className="text-xl font-semibold mb-3 text-yellow-400">{title}</h3>
      <ul className="space-y-3">
        {tracks.map((track, index) => (
          <li key={index} className="flex items-center justify-between  bg-gray-800 p-3 rounded-md hover:bg-gray-900">
            <div className="flex items-center flex-col justify-center xsm:flex-row w-[90%] gap-0 xsm:gap-1 md:gap-4">
              <img
                src={`${credentials.musicImage_URL}/${track.image}`}
                alt={track.title}
                className="w-[120px] h-[100px] rounded-md mx-auto"
              />
              <div className="w-full">
                <h4 className="text-lg font-semibold text-white flex items-center">
                  <FontAwesomeIcon icon={faMusic} className="mr-2 text-yellow-500" />
                  {track.title}
                </h4>
                <p className="text-gray-400 text-sm flex items-center">
                  <FontAwesomeIcon icon={faCalendar} className="mr-2 text-yellow-500" />
                  {track.releaseDate.split("T")[0]}
                </p>
              {track.featuredArtiste[0]!=="" && <p className="text-gray-400 text-sm flex items-center">
                  <FontAwesomeIcon icon={faUser} className="mr-2 text-yellow-500" /> 
                  {track.featuredArtiste}
                </p>}
              </div>
            </div>
         <Link to={`${url}/${track.title}`} >  <FontAwesomeIcon icon={faPlay} className="text-yellow-500 text-4xl cursor-pointer hover:text-yellow-700" /></Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MusicList;
